import { ReactNode } from "react";

interface IInfoAreaTable {
    title: string,
    children: ReactNode;
}

const InfoAreaTable = ({ title, children }: IInfoAreaTable) => {
    return (
        <div className='flex tablet:flex-col items-start tablet:items-start'>
            <p className='w-[170px] text-lg shrink-0'>{title}</p>
            <div className='bg-base rounded min-w-[600px] tablet:min-w-[100%] min-h-12'>
                {children}
            </div>
        </div>
    )
}

export default InfoAreaTable